import { createSlice } from "@reduxjs/toolkit";
import type { TemplateModel } from "../../../models/template";

const initialState = {
  loading: false,
  data: null as TemplateModel | null,
  error: null,
};

const dataSlice = createSlice({
  name: "update-model",
  initialState: initialState,
  reducers: {
    initUpdateDashboardOrder: () => {
      return { ...initialState };
    },
    startUpdateDashboardOrder: (state) => {
      state.loading = true;
    },
    successUpdateDashboardOrder: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorUpdateDashboardOrder: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initUpdateDashboardOrder,
  startUpdateDashboardOrder,
  successUpdateDashboardOrder,
  errorUpdateDashboardOrder,
} = dataSlice.actions;

export default dataSlice.reducer;
